(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wrist-sizing"] && !Shopify.designMode) return;
  try {
    const updateCustomWristField = (container) => {
    const sizeSelect = container.querySelector('[name="properties[Wrist size]"]');
    const customField = container.querySelector('.wrist-sizing__field--custom');
    const customInput = customField?.querySelector('input');

    if (!sizeSelect || !customField || !customInput) return;

    const showCustomField = sizeSelect.value === 'Custom';
    customField.hidden = !showCustomField;
    customInput.disabled = !showCustomField;
    customInput.required = showCustomField;

    if (!showCustomField) customInput.value = '';
  };

  const initializeWristSizing = (root = document) => {
    root.querySelectorAll('[data-wrist-sizing]').forEach(updateCustomWristField);
  };

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-wrist-sizing] [name="properties[Wrist size]"]')) return;
    updateCustomWristField(event.target.closest('[data-wrist-sizing]'));
  });

  document.addEventListener('DOMContentLoaded', () => initializeWristSizing());
  document.addEventListener('shopify:section:load', (event) => initializeWristSizing(event.target));
  } catch(e) { console.error(e); }
})();

})();
